"use client";

import { SiteNav, SiteFooter, SUPPORT_STYLES, LEGAL_STYLES } from "./chrome";
import { STYLES as BASE_STYLES } from "./LandingV2";

export default function LegalShell({
  eyebrow,
  title,
  intro,
  lastUpdated,
  children,
}: {
  eyebrow: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  lastUpdated?: string;
  children: React.ReactNode;
}) {
  return (
    <div className="lvlup-landing">
      <style
        dangerouslySetInnerHTML={{
          __html: BASE_STYLES + SUPPORT_STYLES + LEGAL_STYLES,
        }}
      />
      <SiteNav />

      <main>
      <section className="sp-hero">
        <div className="sp-hero-grid" />
        <div className="sp-hero-glow" />
        <div className="lp-container sp-hero-inner">
          <span className="lp-eyebrow">{eyebrow}</span>
          <h1>{title}</h1>
          {intro && <p className="sp-lead">{intro}</p>}
          {lastUpdated && <div className="lg-updated">Last updated: {lastUpdated}</div>}
        </div>
      </section>

      <section className="lg-section">
        <div className="lp-container">
          <div className="lg-content">{children}</div>
        </div>
      </section>
      </main>

      <SiteFooter />
    </div>
  );
}
